import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { PATH_RESEARCH } from '../../../home/constants/HomeConstants'
import AppStore from '../../../store/AppStore'
import UUID from 'uuid'
import i18n from 'simple-react-i18n'

class NewSelectionPanel extends Component {

	constructor(props) {
		super(props)
	}

	redirect = () => {
		AppStore.dispatch(push(`${ PATH_RESEARCH }/open`))
	}

	render() {
		return (
			<div key={ UUID.v4() } id={ this.props.id } className='col s2 ' onClick={ () => this.redirect() }>
				<div className='card newSelectionPanel valign-wrapper center center-align z-depth-2 clickable hoverable'>
					<div className='fullWidth'>
						<h5>
							{ i18n.addNewSelection }
						</h5>
						<h5>
							<i className='material-icons'>add_circle_outline</i>
						</h5>
					</div>
				</div>
			</div>
		)
	}
}

NewSelectionPanel.propTypes = {
	id: PropTypes.number
}
NewSelectionPanel.defaultProps = {
	id: 0
}
export default NewSelectionPanel



// WEBPACK FOOTER //
// ./src/dashboard/components/selections/NewSelectionPanel.js